import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import {
  SearchInputContainer,
  StyledActionItem,
  StyledSearchInput,
} from './styles';
import { colors } from '@tphglobal/common/theme/style.palette';
import messages from '../messages';

interface Props {
  connectFilter?: any;
  maxWidth?: string;
  minWidth?: string;
  searchInput?: string;
  setSearchInput?: (searchInput?: string) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

export const SearchInputButton: React.FC<any> = ({
  onChange,
  value,
  maxWidth,
  minWidth,
  onKeyDown,
  ...props
}) => (
  <StyledSearchInput
    {...props}
    minWidth={minWidth}
    maxWidth={maxWidth}
    value={value || ''}
    onChange={(e) => {
      if (onChange) {
        onChange(e?.target?.value);
      }
    }}
    onKeyDown={onKeyDown}
  />
);

const SearchInput: React.FC<Props> = ({
  connectFilter,
  maxWidth,
  minWidth,
  searchInput,
  setSearchInput,
  onKeyDown,
}) => (
  <StyledActionItem>
    <SearchInputContainer data-testid='search-input'>
      {connectFilter ? (
        connectFilter('search', {
          autoApplyFilters: true,
          placeholder: messages?.general?.search,
          maxWidth: maxWidth,
          minWidth: minWidth,
        })(SearchInputButton)
      ) : (
        <SearchInputButton
          placeholder={messages?.general?.search}
          value={searchInput}
          onChange={setSearchInput}
          minWidth={minWidth}
          maxWidth={maxWidth}
          onKeyDown={onKeyDown}
        />
      )}
      <SearchIcon
        fontSize='medium'
        style={{
          height: '21px',
          width: '21px',
          padding: '13.5px 0',
          color: colors?.black,
        }}
      />
    </SearchInputContainer>
  </StyledActionItem>
);

export default SearchInput;
